import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Align } from '@progress/kendo-angular-popup';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import { ISousSysteme } from '../../../_models/SousSysteme';
import {
  getAllSousSystemes,
  getIsSousSystemeLoading,
  loadSousSystemesAction,
} from '../../../_store/SousSystemeStore/sous-systeme.store';
import { SousSystemeService } from '../../../_services/http/sous-systeme.service';
import { ConfigService } from '../../../_services/local/config.service';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss'],
})
export class MonitoringComponent implements OnInit {
  isLoading$ = this.store.select(getIsSousSystemeLoading);
  subSystems$ = this.store.select(getAllSousSystemes);
  show = false;
  anchorAlign: Align = {
    horizontal: 'left',
    vertical: 'bottom',
  };

  readonly colors = this.configService.Config.colors.sousSystemes;

  summarySubSystemState!: number;
  summary!: string;

  @ViewChild('anchor') public anchor!: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup!: ElementRef;

  @HostListener('keydown', ['$event'])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  constructor(
    private store: Store<MainStoreState>,
    private service: SousSystemeService,
    private configService: ConfigService
  ) {
    this.subSystems$.subscribe((subSystems) => {
      let ok = 0;
      let ko = 0;
      for (const s of subSystems) {
        if (s.idEtatSysteme === 1) {
          ok++;
        } else if (s.idEtatSysteme === 2) {
          this.summarySubSystemState = 2;
          ko++;
        }
      }

      if (ok === subSystems.length) {
        this.summarySubSystemState = 1;
        this.summary = '';
      }

      if (ko > 0) {
        this.summarySubSystemState = 3;
        this.summary = `${ko}/${subSystems.length}`;
      }

      if (ko === subSystems.length) {
        this.summarySubSystemState = 2;
        this.summary = `${ko}/${subSystems.length}`;
      }
    });
  }

  ngOnInit(): void {
    this.store.dispatch(loadSousSystemesAction());
    this.service.refreshHubConnection();
  }

  public onClick(ss: ISousSysteme): void {
    this.toggle(false);
  }

  public onActionClick(name: string): void {
    this.toggle(false);
  }

  public toggle(show?: boolean): void {
    this.show = show !== undefined ? show : !this.show;
  }

  private contains(target: any): boolean {
    return (
      (this.anchor &&
        this.anchor.nativeElement &&
        this.anchor.nativeElement.contains(target)) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
